/**************************************************
 * Nombre:       Home_Calculadora
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {ArrowForward} from "@mui/icons-material";
import carpeta from '../../../Recursos/carpeta.png'
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {useNavigate} from "react-router-dom";


const Home_Calculadora = () => {
    const {sCell} = useResponsive()
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        backgroundColor: '#2EC2D830',
                        px: sCell ? 4 : 6,
                        py: sCell ? 4 : 8,
                        borderRadius: 10
                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography
                                    sx={{color: '#10434A', fontSize: sCell ? 32 : 40, fontWeight: 600, lineHeight: 1.2}}
                                >Calculadora de ahorro</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                                <Typography
                                    sx={{color: '#010101', fontSize: 16, fontWeight: 400}}
                                >
                                    Proyecta tus ahorros y mira hasta dónde puedes llegar. Descubre cómo tu esfuerzo
                                    crece con el tiempo y te acerca al futuro que sueñas.
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                                <Button
                                onClick={() => navigate('/calculadora')}
                                >
                                    <Typography sx={{fontWeight: 500, pl: 3, pr: 2, color: '#fff'}}>Ver Calculadora</Typography>
                                    <span><IconButton
                                        sx={{backgroundColor: '#fff'}}><ArrowForward
                                        sx={{width: 16, height: 16, fill: '#010101'}}/></IconButton></span> </Button>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}/>

                    {!sCell &&
                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-end'}}>
                            <img src={carpeta} alt="Carpeta" width={400} height={'auto'}/>
                        </Grid>
                    }

                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Calculadora
